import React from 'react';

import * as Dialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import './stylesreset.css';
import { UserContext } from '../UserProvider';
import * as Tabs from '@radix-ui/react-tabs';

const ResetPassword = () => {
  const {
    handleLogin,
    handleSignUp,
    handleConfirmSignUp,
    setIsAuthModalOpen,
    handleRequestResetPassword,
    handleConfirmResetPassword,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    authDialogOpen,
    setAuthDialogOpen,
    resetPasswordDialogOpen,
    setResetPasswordDialogOpen,
    resetPasswordConfirmationCode,
    setResetPasswordConfirmationCode,
  } = React.useContext(UserContext);
  const [code, setCode] = React.useState('');
  const [awaitingConfirmation, setAwaitingConfirmation] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState('tab1');

  const passwordIsLongEnough = password.length >= 8;
  const passwordContainsNumber = /\d/.test(password);
  const passwordContainsSpecialCharacter =
    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
  const passwordContainsUppercase = /[A-Z]/.test(password);
  const passwordContainsLowercase = /[a-z]/.test(password);
  const passwordMatchesConfirm =
    password === confirmPassword && password.length > 0;
  const passwordIsValid =
    passwordIsLongEnough &&
    passwordContainsNumber &&
    passwordContainsSpecialCharacter &&
    passwordContainsUppercase &&
    passwordContainsLowercase &&
    passwordMatchesConfirm;

  // function handleLoginAttempt() {
  //   handleLogin(email, password);
  //   setDialogOpen(false);
  //   setIsAuthModalOpen(false);
  // }
  function handleRequestResetPasswordAttempt() {
    console.log('attempting');
    console.log(`emailVAR=${email}`);
    handleRequestResetPassword(email);
    setActiveTab('tab2');
  }

  function handleConfirmResetPasswordAttempt() {
    console.log('attempting');
    console.log(`emailVAR=${email}`);
    handleConfirmResetPassword();
    setActiveTab('tab1');
    setResetPasswordDialogOpen(false);
    setAuthDialogOpen(false);
    setTimeout(() => {
      handleLogin(email, password);
    }, 1000);
  }

  // function handleConfirmSignUpAttempt() {
  //   handleConfirmSignUp(email, code);
  //   setAwaitingConfirmation(false);
  //   setTimeout(() => {
  //     handleLogin(email, password);
  //   }, 1000);
  //   setDialogOpen(false);
  //   setIsAuthModalOpen(false);
  // }

  const signUpForm = (
    <>
      <p className='Text'>Create an account!</p>
      <Dialog.Description className='ResetPasswordDescription'></Dialog.Description>
      <fieldset className='Fieldset'>
        <label className='Label' htmlFor='email'>
          Email: {email}
        </label>
      </fieldset>
      <fieldset className='Fieldset'>
        <label className='Label' htmlFor='resetpasswordconfirmationcode'>
          Confirmation Code: (emailed to you)
        </label>
        <input
          value={resetPasswordConfirmationCode}
          onChange={(e) => setResetPasswordConfirmationCode(e.target.value)}
          className='Input'
          id='resetpasswordconfirmationcode'
          type='resetpasswordconfirmationcode'
        />
      </fieldset>
      <fieldset className='Fieldset'>
        <label className='Label' htmlFor='password'>
          Password
        </label>
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className='Input'
          id='password'
          type='password'
        />
      </fieldset>
      <fieldset className='Fieldset'>
        <label className='Label' htmlFor='confirmpassword'>
          Confirm Password
        </label>
        <input
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className='Input'
          id='password'
          type='password'
        />
      </fieldset>
      {passwordIsLongEnough ? (
        <div style={{ color: 'green' }}>&gt;= 8 characters long</div>
      ) : (
        <div style={{ color: 'red' }}>&lt; 8 characters long!</div>
      )}
      {passwordContainsNumber ? (
        <div style={{ color: 'green' }}>&gt;=1 number</div>
      ) : (
        <div style={{ color: 'red' }}>&lt;1 number!</div>
      )}
      {passwordContainsSpecialCharacter ? (
        <div style={{ color: 'green' }}>&gt;=1 special character</div>
      ) : (
        <div style={{ color: 'red' }}>&lt;1 special character</div>
      )}
      {passwordContainsUppercase ? (
        <div style={{ color: 'green' }}>&gt;=1 uppercase letter</div>
      ) : (
        <div style={{ color: 'red' }}>&lt;1 uppercase letter</div>
      )}
      {passwordContainsLowercase ? (
        <div style={{ color: 'green' }}>&gt;=1 lowercase letter</div>
      ) : (
        <div style={{ color: 'red' }}>&lt;1 lowercase letter</div>
      )}
      {passwordMatchesConfirm ? (
        <div style={{ color: 'green' }}>Password matches confirm</div>
      ) : (
        <div style={{ color: 'red' }}>Password & confirm don't match</div>
      )}
      <div
        style={{
          display: 'flex',
          marginTop: 20,
          justifyContent: 'flex-end',
        }}
      >
        <button
          onClick={handleConfirmResetPasswordAttempt}
          className='Button green'
        >
          Reset Password
        </button>
      </div>
    </>
  );

  const confirmForm = (
    <>
      <p className='Text'>{`Enter Confirmation Code Sent to ${email}`}</p>
      <Dialog.Description className='ResetPasswordDescription'></Dialog.Description>
      <fieldset className='Fieldset'>
        <label className='Label' htmlFor='code'>
          Confirmation Code
        </label>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className='Input'
          id='code'
          type='text'
        />
      </fieldset>
      <div
        style={{
          display: 'flex',
          marginTop: 20,
          justifyContent: 'flex-end',
        }}
      >
        {/* <button onClick={handleConfirmSignUpAttempt} className='Button green'> */}
        <button onClick={null} className='Button green'>
          Confirm
        </button>
      </div>
    </>
  );

  const signUpTabContent = awaitingConfirmation ? confirmForm : signUpForm;

  return (
    <Dialog.Root
      open={resetPasswordDialogOpen}
      onOpenChange={() => {
        setResetPasswordDialogOpen((oldValue) => {
          setIsAuthModalOpen(!oldValue);
          return !oldValue;
        });
      }}
    >
      <Dialog.Trigger asChild>
        <div className='Button violet'>Reset</div>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className='AuthDialogOverlay' />
        <Dialog.Content className='AuthDialogContent' asChild>
          <Tabs.Root className='TabsRoot' value={activeTab}>
            <Tabs.List className='TabsList' aria-label='Manage your account'>
              <Tabs.Trigger
                className='TabsTriggerRP'
                value='tab1'
                disabled={true}
              >
                Get Code
              </Tabs.Trigger>
              <Tabs.Trigger
                className='TabsTriggerRP'
                value='tab2'
                disabled={true}
              >
                Reset Password
              </Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content className='TabsContent' value='tab1'>
              <p className='Text'>Use the email you signed up with.</p>
              <fieldset className='Fieldset'>
                <label className='Label' htmlFor='email'>
                  Email
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className='Input'
                  id='email'
                  type='email'
                />
              </fieldset>

              <div
                style={{
                  display: 'flex',
                  marginTop: 20,
                  justifyContent: 'flex-end',
                }}
              >
                {/* <button onClick={handleLoginAttempt} className='Button green'> */}
                <button
                  onClick={handleRequestResetPasswordAttempt}
                  className='Button red'
                >
                  Reset
                </button>
              </div>
            </Tabs.Content>
            <Tabs.Content className='TabsContent' value='tab2'>
              {signUpTabContent}
            </Tabs.Content>
          </Tabs.Root>
          {/* <Dialog.Title className="DialogTitle">Login</Dialog.Title>
          <Dialog.Description className="DialogDescription">
            Log in or create an account if you don't already have one!
          </Dialog.Description>
          <fieldset className="Fieldset">
            <label className="Label" htmlFor="email">
              Email
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="Input"
              id="email"
              type="email"
            />
          </fieldset>
          <fieldset className="Fieldset">
            <label className="Label" htmlFor="password">
              Password
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="Input"
              id="password"
              type="password"
            />
          </fieldset>
          <div
            style={{
              display: 'flex',
              marginTop: 25,
              justifyContent: 'flex-end',
            }}
          >
            <Dialog.Close asChild>
              <button onClick={handleLoginAttempt} className="Button mauve">
                Log in
              </button>
            </Dialog.Close>
          </div>
          <Dialog.Close asChild>
            <button className="IconButton" aria-label="Close">
              <Cross2Icon />
            </button>
          </Dialog.Close> */}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
export default ResetPassword;
